import styled from 'styled-components'

export const Content = styled.div`
  padding: 30px;
  padding-top: 0;
`
